<div class="wrapper-list-search-accounts">
    <span class="title-search-results">
        {{'SEARCH.companies' | translate}}
    </span>
    <div #companiesContainer (scroll)="onScroll()">
        <div *ngFor="let company of companies" [routerLink]="[PAGES_AND_PATHS.profile.pagePath, company.username]" class="wrapper-card-lister">
            <div class="wrapper-favorite-lister">
                <div class="wrapper-avatar">
                    <img [src]="company?.profile_photo_url ? company?.profile_photo_url : './assets/images/avatar-user-expert.png'"
                        alt="">
                </div>
                <div class="wrapper-user-info">
                    <div class="wrapper-username">
                        <span>{{company.username}}</span>
                        <img src="./assets/icons/fill/icon-fill-company.svg" alt="">
                    </div>
                    <span>{{company?.followers_count}} {{company.followers_count === 1 ? ('GENERAL.followers' | translate) : ('GENERAL.followers' | translate)}}</span>
                </div>
            </div>
        </div>
    </div>
</div>